import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './HowItWorks.css';

const steps = [
    {
        step: '01',
        title: 'View Properties',
        description:
            'Browse listings, open full property details, and shortlist homes that fit your budget, area, and furnishing preference.',
    },
    {
        step: '02',
        title: 'Call To Reserve',
        description:
            'Once you like a property, call us directly. We help you confirm availability, discuss the next step, and reserve the home quickly.',
    },
    {
        step: '03',
        title: 'We Handle The Rest',
        description:
            'Our team coordinates the owner side, helps with follow-up, and keeps the process moving so you do not have to chase multiple people.',
    },
];

const supportPoints = [
    'Property shortlisting based on your requirement',
    'Direct assistance on availability and reservation',
    'Coordination with owners and follow-up support',
    'Faster movement from enquiry to confirmed booking',
];

const HowItWorks = () => {
    const [showHeroCalls, setShowHeroCalls] = useState(false);
    const [showFooterCalls, setShowFooterCalls] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="how-page">
            <SEO
                title="How It Works | The Rent Company"
                description="See how The Rent Company helps you view properties, call to reserve, and let our team handle the rest."
                path="/how-it-works"
            />
            <Navbar />

            <main className="how-main">
                <section className="how-hero">
                    <div className="how-hero-inner">
                        <div className="how-hero-copy">
                            <span className="how-eyebrow">How It Works</span>
                            <h1>
                                You find the property.
                                <br />
                                We help close the process.
                            </h1>
                            <p>
                                The flow is simple. View properties, call to reserve the one you like,
                                and our team handles the coordination after that.
                            </p>
                            <div className="how-hero-actions">
                                <Link to="/search" className="how-btn how-btn-dark">
                                    View Properties
                                </Link>
                                <div className="how-call-picker">
                                    <button
                                        type="button"
                                        className="how-btn how-btn-light how-btn-plain"
                                        onClick={() => setShowHeroCalls((value) => !value)}
                                    >
                                        Call
                                    </button>
                                    {showHeroCalls && (
                                        <div className="how-call-menu">
                                            <a href="tel:+919620981400" className="how-call-option">
                                                +91 96209 81400
                                            </a>
                                            <a href="tel:+916366699999" className="how-call-option">
                                                +91 63666 99999
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="how-hero-panel">
                            <div className="hero-panel-card">
                                <span className="panel-label">Simple flow</span>
                                <div className="panel-stat">3 steps</div>
                                <p>No complicated application chain. Just shortlist, call, reserve.</p>
                            </div>
                            <div className="hero-panel-grid">
                                <div className="mini-panel">
                                    <strong>Step 1</strong>
                                    <span>Browse</span>
                                </div>
                                <div className="mini-panel">
                                    <strong>Step 2</strong>
                                    <span>Call</span>
                                </div>
                                <div className="mini-panel">
                                    <strong>Step 3</strong>
                                    <span>Reserve</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="how-steps-section">
                    <div className="how-section-head">
                        <h2>The actual process</h2>
                        <p>
                            This is how most users complete their booking journey with us.
                        </p>
                    </div>

                    <div className="how-steps-grid">
                        {steps.map((item) => (
                            <article className="how-step-card" key={item.step}>
                                <div className="how-step-number">{item.step}</div>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="how-support-section">
                    <div className="how-support-copy">
                        <span className="how-eyebrow">What We Handle</span>
                        <h2>You do not need to manage the whole chain alone.</h2>
                        <p>
                            Once you reserve a property with us, our team steps in to support the
                            communication and movement needed to keep the booking progressing.
                        </p>
                    </div>

                    <div className="how-support-card">
                        {supportPoints.map((point) => (
                            <div className="support-point" key={point}>
                                <span className="support-icon">•</span>
                                <span>{point}</span>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="how-cta">
                    <h2>Ready to start?</h2>
                    <p>View available listings or call our team to reserve a property faster.</p>
                    <div className="how-hero-actions">
                        <Link to="/search" className="how-btn how-btn-dark">
                            Browse Listings
                        </Link>
                        <div className="how-call-picker">
                            <button
                                type="button"
                                className="how-btn how-btn-light how-btn-plain"
                                onClick={() => setShowFooterCalls((value) => !value)}
                            >
                                Call
                            </button>
                            {showFooterCalls && (
                                <div className="how-call-menu">
                                    <a href="tel:+919620981400" className="how-call-option">
                                        +91 96209 81400
                                    </a>
                                    <a href="tel:+916366699999" className="how-call-option">
                                        +91 63666 99999
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default HowItWorks;
